import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_yandexmetrikaplugin27716ce3_91209844 from 'nuxt_plugin_yandexmetrikaplugin27716ce3_91209844' // Source: ./yandex-metrika.plugin.27716ce3.js (mode: 'client')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_busevents_1b26e4ba from 'nuxt_plugin_busevents_1b26e4ba' // Source: ../plugins/bus-events.js (mode: 'all')
import nuxt_plugin_vuejsmodal_0719e4a0 from 'nuxt_plugin_vuejsmodal_0719e4a0' // Source: ../plugins/vue-js-modal.js (mode: 'all')
import nuxt_plugin_axios_54e49ad0 from 'nuxt_plugin_axios_54e49ad0' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_customBeforeEach_814c62a2 from 'nuxt_plugin_customBeforeEach_814c62a2' // Source: ../plugins/customBeforeEach.js (mode: 'all')
import nuxt_plugin_vuemask_613243e6 from 'nuxt_plugin_vuemask_613243e6' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_vueclickoutside_47225156 from 'nuxt_plugin_vueclickoutside_47225156' // Source: ../plugins/vue-click-outside.js (mode: 'all')
import nuxt_plugin_imageEditor_626cf5e6 from 'nuxt_plugin_imageEditor_626cf5e6' // Source: ../plugins/imageEditor.js (mode: 'all')
import nuxt_plugin_vuenumword_0c4c58e8 from 'nuxt_plugin_vuenumword_0c4c58e8' // Source: ../plugins/vue-num-word.js (mode: 'all')
import nuxt_plugin_nuxtclientinitclient_6d4f9206 from 'nuxt_plugin_nuxtclientinitclient_6d4f9206' // Source: ../plugins/nuxt-client-init.client.js (mode: 'client')
import nuxt_plugin_vuetextstyle_7cee2770 from 'nuxt_plugin_vuetextstyle_7cee2770' // Source: ../plugins/vue-text-style.js (mode: 'all')
import nuxt_plugin_vuecalendar_741ac10a from 'nuxt_plugin_vuecalendar_741ac10a' // Source: ../plugins/vue-calendar.js (mode: 'all')
import nuxt_plugin_routeclient_379d7c30 from 'nuxt_plugin_routeclient_379d7c30' // Source: ../plugins/route.client.js (mode: 'client')
import nuxt_plugin_lottie_3bb267fe from 'nuxt_plugin_lottie_3bb267fe' // Source: ../plugins/lottie.js (mode: 'all')
import nuxt_plugin_auth_7543862a from 'nuxt_plugin_auth_7543862a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Daichi","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileImage","content":"\u002Ffavicon\u002Fmstile-150x150.png"},{"name":"msapplication-config","content":"\u002Fbrowserconfig.xml"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","size":"16x16","type":"image\u002Fpng","href":"\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"icon","size":"32x32","type":"image\u002Fpng","href":"\u002Ffavicon\u002Ffavicon-32x32.png"},{"rel":"icon","size":"192x192","type":"image\u002Fpng","href":"\u002Ffavicon\u002Fandroid-chrome-192x192.png"},{"rel":"apple-touch-icon","size":"60x60","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"72x72","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"76x76","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"114x114","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"120x120","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"144x144","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"152x152","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"152x152","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","size":"180x180","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"manifest","href":".\u002Fsite.webmanifest.json"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"script":[{"src":"https:\u002F\u002Fstatic.yandex.net\u002Fbrowser-updater\u002Fv1\u002Fscript.js","type":"text\u002Fjavascript","charset":"utf-8","body":true},{"src":"\u002FolbBrowser.js","body":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugin27716ce3_91209844 === 'function') {
    await nuxt_plugin_yandexmetrikaplugin27716ce3_91209844(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_busevents_1b26e4ba === 'function') {
    await nuxt_plugin_busevents_1b26e4ba(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_0719e4a0 === 'function') {
    await nuxt_plugin_vuejsmodal_0719e4a0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_54e49ad0 === 'function') {
    await nuxt_plugin_axios_54e49ad0(app.context, inject)
  }

  if (typeof nuxt_plugin_customBeforeEach_814c62a2 === 'function') {
    await nuxt_plugin_customBeforeEach_814c62a2(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_613243e6 === 'function') {
    await nuxt_plugin_vuemask_613243e6(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclickoutside_47225156 === 'function') {
    await nuxt_plugin_vueclickoutside_47225156(app.context, inject)
  }

  if (typeof nuxt_plugin_imageEditor_626cf5e6 === 'function') {
    await nuxt_plugin_imageEditor_626cf5e6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuenumword_0c4c58e8 === 'function') {
    await nuxt_plugin_vuenumword_0c4c58e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinitclient_6d4f9206 === 'function') {
    await nuxt_plugin_nuxtclientinitclient_6d4f9206(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetextstyle_7cee2770 === 'function') {
    await nuxt_plugin_vuetextstyle_7cee2770(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecalendar_741ac10a === 'function') {
    await nuxt_plugin_vuecalendar_741ac10a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routeclient_379d7c30 === 'function') {
    await nuxt_plugin_routeclient_379d7c30(app.context, inject)
  }

  if (typeof nuxt_plugin_lottie_3bb267fe === 'function') {
    await nuxt_plugin_lottie_3bb267fe(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7543862a === 'function') {
    await nuxt_plugin_auth_7543862a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
